import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormControlProps } from '../../types';
import { CheckboxArea } from '../components/checkboxArea';

import { OljeKamin } from './oljeKamin';
import { OljeKjel } from './oljeKjel';

const emptyValue = {
  kamin: {
    selected: false,
    value: undefined
  },
  kjel: {
    selected: false,
    value: undefined
  }
};

export const Olje: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name="oppvarmingSelection.oppvarmingOlje"
      control={control}
      rules={{
        validate: (value, formValues) => {
          const olje = formValues.oppvarming?.oppvarmingOlje;

          // If "Olje" is selected, at least one of Kjel or Kamin must be selected
          if (!!value && !olje?.kjel?.selected && !olje?.kamin?.selected) {
            return t('register.errorMessage.field.oppvarmingOlje');
          }
          return true;
        }
      }}
      render={({ field: { value, onChange }, fieldState }) => (
        <CheckboxArea
          value={!!value}
          error={fieldState.error}
          i18nPrefix="register.tekniskUtstyr.oppvarmingOlje"
          onChange={(checked) => {
            onChange(checked);
            if (!checked) {
              setValue(`oppvarming.oppvarmingOlje`, emptyValue);
            }
          }}
        >
          <Box gap={3} display="flex" flexDirection="column">
            <OljeKamin control={control} />
            <OljeKjel control={control} />
          </Box>
        </CheckboxArea>
      )}
    />
  );
};
